import axios from 'axios';
import router from '@/router'
import { API_BASE_URL } from '@/config/runtime';

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

let store = null;
let isHandlingUnauthorized = false;

export const setStore = (s) => {
  store = s;
};

const session = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
});

session.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const requestUrl = error?.config?.url;
  const isLoginRequest = requestUrl?.includes('/auth/login/');
  const isLogoutRequest = requestUrl?.includes('/auth/logout/');
  const isAdminNewsRequest = requestUrl?.includes('/admin_news/');
  const isSilentRequest = isLoginRequest || isLogoutRequest || isAdminNewsRequest || error?.config?.suppressErrorAlert;

  if (!error.response) {
    const detail = error?.code === 'ECONNABORTED'
      ? 'Request timeout. Please try again.'
      : 'Network error. Please try again.';

    if (store && !isSilentRequest)
      store.commit('notifications/raiseError', { detail });
    return Promise.reject(error);
  }

  if (error.response.status === 500 || error.response.status === 404) {
    return Promise.reject(error);
  }

  if (error.response.status === 403) {
    if (store && !isSilentRequest)
      store.commit('notifications/raiseError', error.response.data);
    return Promise.reject(error);
  }

  if (store && !isSilentRequest)
    store.commit('notifications/raiseError', error.response.data);

  if (error.response.status === 401) {
    const isAuthenticated = !!store?.getters?.['auth/isAuthenticated'];

    if (store && isAuthenticated && !isLoginRequest && !isLogoutRequest && !isHandlingUnauthorized) {
      isHandlingUnauthorized = true;
      store
        .dispatch('auth/logout')
        .catch(() => {})
        .finally(() => {
          if (router.currentRoute.path !== '/login') {
            router.push('/login');
          }
          isHandlingUnauthorized = false;
        });
    }
  }

  return Promise.reject(error);
})


export default session;

